import { render, staticRenderFns } from "./PrintableV2.vue?vue&type=template&id=08ea5168&"
import script from "./PrintableV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrintableV2.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PrintableV2.vue?vue&type=style&index=0&id=08ea5168&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports